import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@/pages/service/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
    const auth = inject(AuthService);
    const jwtHelper = new JwtHelperService();

    const token = auth.getAccessToken();

    if (token) {
        if (jwtHelper.isTokenExpired(token)) {
            auth.logout();
            return next(req);
        }

        const cloned = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
        return next(cloned);
    } else {
        auth.logout();
        return next(req);
    }
};
